import React from 'react';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import markUrl from 'images/landing-affiliates/egb-grey.svg';
import {PARTNER_EMAIL} from './affiliatesLinks';

const AffiliatesFooter = (): React.ReactElement => <footer className="ftr">
    <div className="wrap">
        <a className="egb" href={getLinkPath('/')} aria-label="EGB">
            <img src={markUrl} alt="EGB"/>
        </a>
        <div className="ftr-right">
            <nav className="ftr-links" aria-label={I18n.t('affiliate.terms')}>
                <a href={getLinkPath('/terms_and_conditions')} target="_blank" rel="noopener noreferrer">
                    {I18n.t('affiliate.terms')}
                </a>
                <a href={getLinkPath('/privacy_policy')} target="_blank" rel="noopener noreferrer">
                    {I18n.t('affiliate.privacy')}
                </a>
            </nav>
            <div className="ftr-mail">
                <span>{I18n.t('affiliate.mail')}</span>
                {' '}
                <a href={`mailto:${PARTNER_EMAIL}`}>{PARTNER_EMAIL}</a>
            </div>
        </div>
    </div>
</footer>;

export default AffiliatesFooter;
